export const GET_MLS_FIELDS = 'GET_MLS_FIELDS';

export const getMlsFields = () => ({
  type: GET_MLS_FIELDS
});
